import '@wheely/ui-kit/dist/ui-kit-global.css';
import '@wheely/ui-kit/dist/ui-kit.css';

import '@src-common/view/guide.css';

import { FocusStyleManager } from '@wheely/ui-kit';

FocusStyleManager.onlyShowFocusOnTabs();
